import Product from './Product';
import Slider from 'react-slick';
import { NextBtn, PreviousBtn } from '../Banner/Banner';
import { Link } from 'react-router-dom';
import { offerProducts } from '../../../utils/constants';
import { getRandomProducts } from '../../../utils/functions';
import { Box, Typography, Button, useTheme } from '@mui/material';

export const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 1,
    swipe: false,
    prevArrow: <PreviousBtn />,
    nextArrow: <NextBtn />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const DealSlider = ({ title }) => {
    const theme = useTheme();

    return (
        <Box sx={{
            backgroundColor: theme.palette.background.paper,
            width: '100%',
            boxShadow: 3,
            overflow: 'hidden',
            borderRadius: 2,
            my: 4
        }}>
            <Box sx={{
                display: 'flex',
                px: 3,
                py: 2,
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: `1px solid ${theme.palette.divider}`
            }}>
                <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>{title}</Typography>
                <Button component={Link} to="/products" variant="contained" color="primary" sx={{ textTransform: 'uppercase', boxShadow: 'lg' }}>
                    View All
                </Button>
            </Box>
            <Slider {...settings}>
                {getRandomProducts(offerProducts, 12).map((item, i) => (
                    <Product {...item} key={i} />
                ))}
            </Slider>
        </Box>
    );
};

export default DealSlider;
